'use client';
import { routes } from '~/utils/routes';
import { css } from '@styled-system/css';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  userId: string;
};

export const ProfileEditButtonContainer = ({ userId }: Props) => {
  const { isMe } = useLocalHooks(userId);

  if (!isMe) {
    return null;
  }

  return (
    <a
      href={routes.profileEdit.url()}
      className={css({
        color: 'accent.1000',
        backgroundColor: 'white',
        borderRadius: '2em',
        borderColor: 'accent.1000',
        borderStyle: 'solid',
        borderWidth: '1px',
        fontWeight: 600,
        width: '160px',
        fontSize: 'size_12',
        height: '28px',
        padding: '8px 16px',
      })}
    >
      プロフィールを編集
    </a>
  );
};
